'use client';

// In-page replacements for window.alert / window.confirm, rendered by
// components/DialogHost.tsx, which loads once the page is ready
// (components/LateWidgets.tsx): a message sent before then waits for it.

import { sendToWidget } from '@/lib/late-widgets';

export type NoticeTone = 'info' | 'success' | 'error';

export interface ConfirmOptions {
  title?: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  danger?: boolean;
}

export const NOTIFY_EVENT = 'rec:notify';
export const CONFIRM_EVENT = 'rec:confirm';
export const PROMPT_EVENT = 'rec:prompt';

export interface PromptOptions {
  title?: string;
  message: string;
  placeholder?: string;
  initial?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  maxLength?: number;
}

export function notify(message: string, tone: NoticeTone = 'info') {
  if (typeof window === 'undefined') return;
  sendToWidget(NOTIFY_EVENT, { message, tone });
}

export function confirmDialog(options: ConfirmOptions | string): Promise<boolean> {
  if (typeof window === 'undefined') return Promise.resolve(false);
  const opts = typeof options === 'string' ? { message: options } : options;
  return new Promise((resolve) => {
    sendToWidget(CONFIRM_EVENT, { ...opts, resolve });
  });
}

/** In place of window.prompt: the text typed, or null when it was cancelled. */
export function promptDialog(options: PromptOptions): Promise<string | null> {
  if (typeof window === 'undefined') return Promise.resolve(null);
  return new Promise((resolve) => {
    sendToWidget(PROMPT_EVENT, { ...options, resolve });
  });
}
